import gql from 'graphql-tag';

/**
 * Mutation to add (restore) an item on an inspection template (building fork).
 */
export const addItemToTemplateMutation = gql`
  mutation AddItemToTemplate($input: AddItemToTemplateInput!) {
    addItemToTemplate(input: $input) {
      success
      newVersion
    }
  }
`;
